// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"195":"login1","289":"login43","577":"login3"}[chunkId] + "." + {"195":"65968576","289":"0525c385","577":"8266c24a"}[chunkId] + ".css";
};